import React, { useMemo } from "react";
import { Box } from "@usap/uicomponents";
import { TextWithPointer } from "../StyledCSS";
import Label from "./Label";

export default function DoesNotFitContainer({
  cart,
  vehicleString,
  selectedVehicle,
  addVehicleTrigger,
  redirectSearch,
  orderItemId,
  firstLabelText,
  isPdpRp1Enabled,
  dataTestPrefix = '',
}) {
  const styleManager = useMemo(() => ({
    paddingLeft: { left: 'small' },
    marginTop: { top: 'small' },
    correctPartStyle: {
      borderRight: '1px solid #E0E0E0',
      paddingRight: '8px',
      textDecoration: 'underline',
    },
    changeVehicleStyle: {
      paddingLeft: '8px',
      textDecoration: 'underline',
    },
    doesNotFitLabelStyle: isPdpRp1Enabled ? {
      color: '#FF4040',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
      fontWeight: 'bold',
    } : {},
  }), [isPdpRp1Enabled])

  return (
    <Box pad={styleManager.paddingLeft} align="start" justify="center">
      <Label style={styleManager.doesNotFitLabelStyle}>
        {firstLabelText}
      </Label>
      <Label>{cart ? vehicleString : ""}</Label>
      {selectedVehicle && !cart && <Label size="small">{vehicleString}</Label>}
      {addVehicleTrigger && redirectSearch && (
        <Box
          direction="row"
          align="center"
          justify="between"
          margin={styleManager.marginTop}
        >
          <TextWithPointer
            color="blueLink"
            weight="bold"
            fxSize={{ large: "14px", other: "12px" }}
            onClick={() => redirectSearch(true, "vselector")}
            style={styleManager.correctPartStyle}
            data-testid={`${dataTestPrefix}this-part-does-not-fit-view-correct-part-pdp`}
          >
            View Correct Part
          </TextWithPointer>
          <TextWithPointer
            color="blueLink"
            weight="bold"
            fxSize={{ large: "14px", other: "12px" }}
            onClick={() => addVehicleTrigger(orderItemId, "change")}
            style={styleManager.changeVehicleStyle}
            data-testid={`${dataTestPrefix}this-part-does-not-fit-change-vehicle-pdp`}
          >
            Change Vehicle
          </TextWithPointer>
        </Box>
      )}
    </Box>
  );
}
